"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pointIsInRect = void 0;
var rectangle_1 = require("../types/record/rectangle");
/**
 * @description pointがrectに含まれているかどうか
 */
// prettier-ignore
var pointIsInRect = function (point, rect) {
    return (rect.top <= point.y && point.y <= (0, rectangle_1.bottom)(rect)) &&
        (rect.left <= point.x && point.x <= (0, rectangle_1.right)(rect));
};
exports.pointIsInRect = pointIsInRect;
